import {Component} from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {MatDialog} from "@angular/material/dialog";
import {ICellRendererParams} from "ag-grid-community";
import {EditWinnerPayoutDialogComponent} from "../edit-winner-payout-dialog/edit-winner-payout-dialog.component";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {MatIcon} from "@angular/material/icon";
import {IWinnerPayoutWithWithWinnerInfo} from "../../../interfaces/IWinnerPayoutWithWithWinnerInfo";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {MatDivider} from "@angular/material/divider";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {PermissionTypes} from "../../../enum/PermissionTypes";

@Component({
  selector: 'app-winner-payout-options',
  standalone: true,
  templateUrl: './winner-payout-options.component.html',
  imports: [
    MatButton,
    MatTooltip,
    MatIcon,
    HasPermissionDirective,
    MatDivider,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger
  ],
  styleUrls: ['./winner-payout-options.component.css']
})
export class WinnerPayoutOptionsComponent implements ICellRendererAngularComp {

  public rowData!: IWinnerPayoutWithWithWinnerInfo;
  protected readonly PermissionTypes = PermissionTypes;
  protected gameId: string = '';

  constructor(private matDialog: MatDialog) {
  }

  agInit(params: ICellRendererParams& {
    gameId: string
  }): void {
    this.rowData = params.data;
    this.gameId = params.gameId;
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }

  onPayWinnerClick() {
    const dialog_data = {
      winnerPayout: this.rowData,
      gameId: this.gameId
    };

    this.matDialog.open(EditWinnerPayoutDialogComponent, {
      data: dialog_data,
      width: '650px'
    });
  }

}
